var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconlyBoldChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Chat",
    "data-name": "Iconly/Bold/Chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M9.98,0a10,10,0,1,0,4.94,18.7,1.7,1.7,0,0,1,1.49-.361h0l2.02.6a.625.625,0,0,0,.82-.781h0l-.67-2.243a1.049,1.049,0,0,1,.07-.9,10.588,10.588,0,0,0,1.35-5A10.007,10.007,0,0,0,9.98,0ZM5.41,8.743a1.282,1.282,0,1,1-1.28,1.282A1.277,1.277,0,0,1,5.41,8.743Zm4.61,0a1.275,1.275,0,0,1,1.28,1.272,1.28,1.28,0,1,1-2.56.01A1.277,1.277,0,0,1,10.02,8.743Zm4.61,0a1.277,1.277,0,0,1,1.28,1.282,1.28,1.28,0,1,1-2.56,0A1.277,1.277,0,0,1,14.63,8.743Z",
    fill: "#446fa2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldChat);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Chat.27591c3ba40aedaae60f6e234b1a3341.svg";
export { ForwardRef as ReactComponent };